import { Service } from '@angular/core';

/** The handover is the navigation that follows the wizard, so it is over in seconds. */
const HANDOVER_WINDOW_MS = 30_000;

/**
 * Carries the recurring survey the user just set up from the wizard to the page that
 * confirms it. The wizard is gone by the time that page loads, so the page can't listen for
 * the creation itself. Kept in memory only, and only for as long as that handover should
 * take: if the navigation never arrives — a guard redirected it, the user went elsewhere —
 * the survey is not confirmed hours later on some unrelated visit to the list.
 */
@Service()
export class RecurringSetupCompletedService {
  private surveyId: number | null = null;
  private markedAt = 0;

  markCompleted(surveyId: number): void {
    this.surveyId = surveyId;
    this.markedAt = Date.now();
  }

  /** The survey to confirm, handed out once. */
  consume(): number | null {
    const surveyId = this.surveyId;
    const markedAt = this.markedAt;
    this.surveyId = null;
    this.markedAt = 0;

    return Date.now() - markedAt < HANDOVER_WINDOW_MS ? surveyId : null;
  }
}
